import { CacheService } from './cache.service';
import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/toPromise';
import { Member } from '../interfaces/member.interface';
import { CacheKey } from '../constants/cachekey.constants';
import { CookieService } from 'ngx-cookie-service';
import { SSO } from './../../sso/sso.constants';
import { environment } from '../../../environments/environment';
import { MemberLevel } from '../enums/member-level.enum';
import { MemberType } from '../enums/member-type.enum';

@Injectable()
export class ActiveSessionService {
    private _meberInfo: Member;
    cookieService: CookieService = new CookieService(document);
    constructor(private _cacheService: CacheService) { }

    /**
     * save user info in storage  service
     * @param  {Member} userInfo
     * @returns void
     */
    setUserInfo(userInfo: Member): void {
        if (userInfo) {
            this._cacheService.set(CacheKey.MemberInfo, userInfo);
        }
    }


    /**
     * get user info data from storage service
     * @returns Member
     */
    getUserInfo(): Member {
        if (this._meberInfo) {
            return this._meberInfo;
        } else {
            this._meberInfo = this._cacheService.get(CacheKey.UserInfo);
            if (this._meberInfo) {
                return this._meberInfo;
            } else {
                return null;
            }
        }
    }

    /**
     * remove user info from local storage
     * @returns void
     */
    logout(): void {
        if (SSO.isRemoveObsoleteCookie()) {
            localStorage.removeItem(SSO.ACCESS_TOKEN);
            localStorage.removeItem(SSO.REFRESH_TOKEN);
            localStorage.removeItem(SSO.LOCAL_MEMBER_SESSION_ID);
            localStorage.removeItem(SSO.IS_NEW_TOKEN);
            this.cookieService.delete(SSO.MEMBER_SESSIONID, environment.cookiePath, environment.cookieDomain);
        } else {
            this.cookieService.delete(SSO.ACCESS_TOKEN, environment.cookiePath, environment.cookieDomain);
            this.cookieService.delete(SSO.REFRESH_TOKEN, environment.cookiePath, environment.cookieDomain);
        }
        this.cookieService.delete(SSO.NONCE, environment.cookiePath, environment.cookieDomain);
        this.cookieService.delete(SSO.MEMBER_ID, environment.cookiePath, environment.cookieDomain);
        this.cookieService.delete(CacheKey.hasCartItems, environment.cookiePath, environment.cookieDomain);
        this._cacheService.remove(CacheKey.MemberInfo);
        this._cacheService.remove(CacheKey.CartSessionInfo);
        this._cacheService.remove(CacheKey.CartItems);
        this._cacheService.remove(CacheKey.UserInfo);
        this._cacheService.removeCookieValue(CacheKey.CartSessionGuid);
        if (this._cacheService.getCookieValue(CacheKey.CookieBanner)) {
            this._cacheService.removeCookieValue(CacheKey.CookieBanner);
        }
        // this._cacheService.remove(CacheKey.SSOToken);
    }

    /**
     * get active user id
     * @returns number
     */
    // getUserId(): number {
    //     const userInfo: Member = this.getUserInfo();
    //     if (userInfo) {
    //         return userInfo.userId;
    //     } else {
    //         return 0;
    //     }
    // }

    /**
     * get active member id
     * @returns number
     */
    // getMemberId(): number {
    //     const userInfo: Member = this.getUserInfo();
    //     if (userInfo && userInfo.memberId) {
    //         return userInfo.memberId;
    //     } else {
    //         return 0;
    //     }
    // }

    /**
     * get active member Type Id
     * @returns number
     */
    // getMemberTypeId(): number {
    //     const userInfo: Member = this.getUserInfo();
    //     if (userInfo) {
    //         return userInfo.memberTypeId;
    //     } else {
    //         return 0;
    //     }
    // }

    /**
     * get active member distributor Id
     * @returns number
     */
    getDistributorId(): string {
        const userInfo: Member = this.getUserInfo();
        if (userInfo && userInfo.distributorId) {
            return userInfo.distributorId;
        } else {
            return null;
        }
    }

    /**
     * get active member Title Id
     * @returns number
     */
    getMemberTitleId(): number {
        const userInfo: Member = this.getUserInfo();
        if (userInfo && userInfo.memberTitleId) {
            return userInfo.memberTitleId;
        } else {
            return MemberLevel.RETAIL;
        }
    }

    /**
     * get active member Title Id
     * @returns number
     */
    getMemberTitleIdForProducts(): number {
        const userInfo: Member = this.getUserInfo();
        if (userInfo && userInfo.memberTitleId) {
            if (userInfo.memberTypeId === MemberType.PREFERREDCUSTOMER) {
                return MemberLevel.PREFERREDCUSTOMER;
            } else {
                return userInfo.memberTitleId;
            }
        } else {
            return MemberLevel.RETAIL;
        }
    }


    /**
    * get active member Title
    * @returns string
    */
    // getMemberTitle(): string {
    //     const userInfo: Member = this.getUserInfo();
    //     if (userInfo && userInfo.memberTitle) {
    //         return userInfo.memberTitle;
    //     } else {
    //         return '';
    //     }
    // }

    /**
    * get active member profile image url
    * @returns string
    */
    // getProfileImageURL(): string {
    //     const userInfo: Member = this.getUserInfo();
    //     if (userInfo && userInfo.profileImageURL) {
    //         return userInfo.profileImageURL;
    //     } else {
    //         return '';
    //     }
    // }

    /**
    * get active member user name
    * @returns string
    */
    // getUserName(): string {
    //     const userInfo: Member = this.getUserInfo();
    //     if (userInfo && userInfo.userName) {
    //         return userInfo.userName;
    //     } else {
    //         return '';
    //     }
    // }
}
